<template>
    <div :class="['task-category-card', col]">
        <a :href="url" class="task-category-card__inner">
            <div class="task-category-card__cover">
                <img class="task-category-card__img" :src="image" :alt="title">
            </div>
            <div class="task-category-card__body">
                <div class="task-category-card__main">
                    <div class="task-category-card__title" v-html="title"></div>
                </div>
                <div class="task-category-card__tasks" v-if="count">{{ count }}</div>
            </div>
            <ABtn :href="urlMakeTask" v-if="(isNPO ? (translates?.apply) : (translates?.choose))"
                  :label="isNPO ? (translates?.apply) : (translates?.choose)"
                  class="primary w-100"
            />
        </a>
    </div>
</template>

<script>
import {ABtn} from '../ui'

export default {
    name: 'TaskCategoryCard',
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: '',
        },
        count: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        urlMakeTask: {
          type: String,
          default: '',
        },
        image: {
            type: String,
            default: '',
        },
        col: {
            type: String,
            default: '',
        },
        translates: Object,
        isNPO: Boolean
    },
    components: {
        ABtn
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss">
    .task-category-card {
        position: relative;

        &:hover {
            z-index: 10;

            .a-btn{
                display: flex;
            }
        }

        &__cover {
            display: block;
            line-height: 1px;
            border-radius: var(--br-1);
            overflow: hidden;
            width: 50px;
            height: 50px;
            min-height: 50px;

            @include mobile {
                width: 30px;
                height: 30px;
                min-height: 30px;
            }

            img {
                object-fit: cover;
                width: 100%;
                transition: all .3s ease 0s;
                filter: grayscale(1) brightness(1.3);
            }
        }
        &__inner {
            background: #fff;
            border-radius: var(--br-1);
            overflow: hidden;
            transition: all .3s ease 0s;
            display: flex;
            flex-direction: column;
            background: #fff;
            height: 100%;
            border: 1px solid var(--c-gray-700);
            padding: 24px;

            @include tablet {
                padding: 20px;
            }
            @include mobile {
                padding: 16px 10px;
            }

            &:hover {
                border-color: transparent;
                box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
                text-decoration: none;

                .task-category-card {
                    &__img {
                        filter: none;
                    }
                    &__title {
                        color: var(--c-primary-200);
                    }
                }
            }
        }
        &__body {
            margin-top: 26px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
        }
        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: var(--c-gray-100);
            transition: all .3s ease;

            @include mobile {
                font-size: 12px;
                line-height: 16px;
            }
        }
        &__tasks {
            margin-top: 9px;
            font-size: 14px;
            line-height: 20px;
            color: var(--c-gray-500);

            @include mobile {
                font-size: 12px;
                line-height: 16px;
            }
        }

        .a-btn {
            display: none;
            position: absolute;
            bottom: -40px;
            left: 0;
            width: 100%;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            text-align: center;
            justify-content: center;
        }
    }
</style>
